/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import {
	TextInput as NativeTextInput,
	TextInputProps,
} from '@mantine/core';

// I18n
import { useTranslation } from 'react-i18next';

// Style
import classes from './TextInput.module.css';

// Icons
import { IconExclamationCircle } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const TextInput = (
	props: TextInputProps & {
		onClick?: () => void;
		id?: string;
		size?: string;
		radius?: string;
		label?: string;
		description?: string;
		placeholder?: string;
		variant?: string;
		fullWidth?: boolean;
		withAsterisk?: boolean;
		error?: any;
		disabled?: boolean;
		leftSection?: any;
		visibleFrom?: string;
		hiddenFrom?: string;
	}
) => {
	const { t } = useTranslation();
	const { error, ...restProps } = props;
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeTextInput
			error={t(error)}
			withErrorStyles={true}
			rightSectionPointerEvents="none"
			autoComplete="new-password"
			rightSection={
				error && (
					<IconExclamationCircle
						className={classes.errorIcon}
						color="var(--mantine-color-error)"
					/>
				)
			}
			classNames={classes}
			{...restProps}
		/>
	);
};
